export const FEED_FETCH = 'FEED_FETCH';
export const FEED_FETCH_SUCCESS = 'FEED_FETCH_SUCCESS';
export const FEED_FETCH_ERROR = 'FEED_FETCH_ERROR';
export const feedFetch = (page = 1, isManualFetch = false) => ({type: FEED_FETCH, page, isManualFetch});

export const FEED_RECEIVED = 'FEED_RECEIVED';
export const feedReceived = (page = 1, isManualFetch = false, result) => ({type: FEED_RECEIVED, page, isManualFetch, result});

export const FEED_QUESTIONNAIRES_RECEIVED = 'FEED_QUESTIONNAIRES_RECEIVED';
export const feedQuestionnairesReceived = (result) => ({type: FEED_QUESTIONNAIRES_RECEIVED, result});

export const FEED_QUESTIONNAIRE_UPDATE = 'FEED_QUESTIONNAIRE_UPDATE';
export const feedQuestionnaireUpdate = (feedQuestionnaireId, updates) => ({type: FEED_QUESTIONNAIRE_UPDATE, feedQuestionnaireId, updates});

export const FEED_QUESTION_UPDATE = 'FEED_QUESTION_UPDATE';
export const feedQuestionUpdate = (feedQuestionnaireId, feedQuestionId, updates) => ({type: FEED_QUESTION_UPDATE, feedQuestionnaireId, feedQuestionId, updates});

export const FEED_QUESTIONNAIRE_SUBMIT = 'FEED_QUESTIONNAIRE_SUBMIT';
export const FEED_QUESTIONNAIRE_SUBMIT_SUCCESS = 'FEED_QUESTIONNAIRE_SUBMIT_SUCCESS';
export const FEED_QUESTIONNAIRE_SUBMIT_ERROR = 'FEED_QUESTIONNAIRE_SUBMIT_ERROR';
export const feedQuestionnaireSubmit = feedQuestionnaire => ({type: FEED_QUESTIONNAIRE_SUBMIT, feedQuestionnaire});




/** WEBPACK FOOTER **
 ** ./src/members/state/feed/actions.js
 **/